import * as React from 'react';

import type {
  UsersFilterContextValue,
  UsersFilterProviderProps,
  UsersFilters,
} from './UsersFilterContext.types';

const INITIAL_USERS_FILTERS: UsersFilters = {
  searchText: '',
  roles: [],
  status: [],
};

const UsersFilterContext = React.createContext<
  UsersFilterContextValue | undefined
>(undefined);

const UsersFilterProvider = React.memo(
  ({ children }: Readonly<UsersFilterProviderProps>): React.ReactElement => {
    const [filters, setFiltersState] = React.useState<UsersFilters>(
      INITIAL_USERS_FILTERS
    );

    const isFiltersApplied =
      filters.searchText.length > 0 ||
      filters.roles.length > 0 ||
      filters.status.length > 0;

    const setFilters = React.useCallback(
      (partial: Partial<UsersFilters>): void => {
        setFiltersState(prev => ({ ...prev, ...partial }));
      },
      []
    );

    const clearFilters = React.useCallback((): void => {
      setFiltersState(INITIAL_USERS_FILTERS);
    }, []);

    const value = React.useMemo(
      () => ({
        filters,
        isFiltersApplied,
        setFilters,
        clearFilters,
      }),
      [filters, isFiltersApplied, setFilters, clearFilters]
    );

    return (
      <UsersFilterContext value={value}>
        {children}
      </UsersFilterContext>
    );
  }
);

UsersFilterProvider.displayName = 'UsersFilterProvider';

export { UsersFilterContext, UsersFilterProvider };
